import {Component} from '@angular/core';
import {CommonService} from "../../services/common.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-logout-warning',
  templateUrl: './logout-warning.component.html',
  styleUrls: ['./logout-warning.component.css']
})
export class LogoutWarningComponent {
  constructor(
    private commonService: CommonService,
    private router: Router,
  ) {
  }

  logout() {
    this.router.navigate(['/']).then(() => {
        this.commonService.closeDialog();
      }
    );
  }

}
